import { useState, useEffect } from 'react'
import { useGetTaskList, useGetTaskExecList } from '../utils'
import { CSDataType, CSSubDataType } from '../task-list-main'

export const useTaskData = () => {
  const [getTaskList, getTaskListLoading] = useGetTaskList()
  const [getTaskExecuteList, getTaskExecuteListLoading] = useGetTaskExecList()

  const [total, setTotal] = useState(0)
  const [dataSource, setDataSource] = useState<CSDataType[]>([])
  const [subDataSource, setSubDataSource] = useState<CSSubDataType[]>([])
  const [subTotal, setSubTotal] = useState(0)
  const [count, setCount] = useState(1)
  const [mainTaskName, setMainTaskName] = useState('')

  return {
    getTaskList,
    getTaskExecuteList,
    getTaskListLoading,
    getTaskExecuteListLoading,
    total,
    setTotal,
    dataSource,
    setDataSource,
    subDataSource,
    setSubDataSource,
    subTotal,
    setSubTotal,
    count,
    setCount,
    mainTaskName,
    setMainTaskName,
  }
}
